import React, { useState } from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";

import DemAnticipada from "../DemAnticipada/DemAnticipada";

const ModalDemoraAnticipada = ({
  token,
  idSolicitud,
  idContenedor,
  modalDemoraAnticipadaIsOpen,
  closeDemoraAnticipadaModal,
  dataEir,
}) => {
  
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      width: "60%",
      height: "52%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#ffff",
      borderRadius: "5px",
    },
  };

  return (
    <Modal
      isOpen={modalDemoraAnticipadaIsOpen}
      onRequestClose={closeDemoraAnticipadaModal}
      style={customStyles}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <div className="row m-1">
        <div className="col-12  d-flex flex-row-reverse">
          <button className="btn" onClick={closeDemoraAnticipadaModal}>
            <FaTimes style={{ color: "#F47777" }} />
          </button>
        </div>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-10 mt-5">
        <DemAnticipada 
         idSolicitud={idSolicitud} 
         idContenedor={idContenedor} 
         token={token}
         closeModal={closeDemoraAnticipadaModal}
         dataEir={dataEir}  
         />
         </div>
        </div>
    </Modal>
  );
};

export default ModalDemoraAnticipada;
